<script lang="ts" setup>
import { computed, navigateTo, ref, showError, showErrorMsg } from '#imports';
import type { PropType } from '#imports';
import type { NoviceTaskVO } from '~/types/auto/oj';
import { FRESH_TASK_STATUS, MISSION_TASK_EVENT } from '~/utils/constant';

const props = defineProps({
  item: {
    type: Object as PropType<NoviceTaskVO>,
    required: true,
  },
  joinTraining: {
    type: Function as PropType<(tid: number) => Promise<unknown>>,
    required: true,
  },
});
const emit = defineEmits(['go-compelete-person-info']);
const navigateToProblemDetail = (pid: number, tid?: number) => {
  navigateTo({
    name: 'oj_problem_detail',
    query: {
      pid,
      tid: tid ? tid : undefined,
    },
  });
};
const goCompletePersonInfo = () => {
  emit('go-compelete-person-info');
};

const navigateToContestList = () => {
  navigateTo({
    name: 'oj_contest',
  });
};

const handleClick = async () => {
  switch (props.item.factorType) {
    case MISSION_TASK_EVENT.FILL_IN_INFORMATION:
      goCompletePersonInfo();
      break;

    case MISSION_TASK_EVENT.SUBMIT_PROBLEM:
    case MISSION_TASK_EVENT.FIRST_AC:
    case MISSION_TASK_EVENT.AC:
    case MISSION_TASK_EVENT.TRAINING_SUBMISSION:
    case MISSION_TASK_EVENT.TRAINING_COMPLETION:
      if (props.item.pid) {
        navigateToProblemDetail(props.item.pid, props.item.tid);
      }
      break;
    case MISSION_TASK_EVENT.REGISTER_CONTEST:
      navigateToContestList();
      break;
    default:
      break;
  }
};
const reward = computed(() => {
  return props.item.missionRewardVo?.reduce((pre, cur) => {
    const str = cur.description;
    const num = cur.num!;
    return `${pre}${str}${num > 1 ? `*${num}` : ''} `;
  }, '');
});
const buttonText = computed(() => {
  if (props.item.missionStatus === FRESH_TASK_STATUS.FINISHED) {
    return '已完成';
  }
  if (props.item.factorType === MISSION_TASK_EVENT.TRAINING_COMPLETION) {
    return '去做题';
  }
  return '去完成';
});
</script>

<template>
  <li :key="item.missionId" class="mt-3 list-item">
    <div class="flex-1">
      <h6>{{ item.missionName }}</h6>
      <p>奖励：{{ reward }}</p>
    </div>
    <div>
      <a-button
        v-login
        size="large"
        type="primary"
        class="button"
        :disabled="item.missionStatus === FRESH_TASK_STATUS.FINISHED"
        @click="handleClick"
      >
        {{ buttonText }}
        <template
          v-if="typeof item.totalCount === 'number' && item.totalCount > 1"
        >
          {{ item.completedCount }}/{{ item.totalCount }}
        </template>
      </a-button>
    </div>
  </li>
</template>
<style>
.list-item {
  @apply flex h-[64px] items-center justify-between rounded bg-[#F6F7F8] px-[10px];
}
.list-item h6 {
  @apply py-[1px] font-bold text-font1;
}
.list-item p {
  @apply text-xs text-font2;
}
.list-item .button {
  @apply !flex !h-[26px] min-w-[76px] items-center justify-center !px-1 !py-0 !text-xs;
}
.list-item .button:disabled {
  @apply border-transparent bg-primary text-white opacity-50;
}
</style>
